import axios from 'axios';

// The kiosk keeps its own sign-in, separate from the staff app. Access
// tokens last 24 hours, and the kiosk used to store only that token, so
// every submission a day after the iPad was signed in failed 401 while the
// patient saw a button that did nothing (Danny Perkins 2026-10-29, Cody
// Roszina 2026-10-30). The refresh token slides 90 days on each use, so a
// kiosk in regular use now stays signed in.
export const KIOSK_TOKEN_KEY = 'cervica_kiosk_token';
export const KIOSK_REFRESH_KEY = 'cervica_kiosk_refresh_token';
let kioskRefreshInFlight = null;
export function refreshKioskToken(apiBase, http = axios) {
  if (!kioskRefreshInFlight) {
    const refreshToken = localStorage.getItem(KIOSK_REFRESH_KEY);
    kioskRefreshInFlight = (refreshToken
      ? http.post(`${apiBase}/auth/refresh`, { refreshToken }).then(({ data }) => {
        if (typeof data?.token !== 'string' || !data.token || typeof data?.refreshToken !== 'string' || !data.refreshToken) {
          throw new Error('The kiosk sign-in could not be renewed.');
        }
        localStorage.setItem(KIOSK_TOKEN_KEY, data.token);
        localStorage.setItem(KIOSK_REFRESH_KEY, data.refreshToken);
        return data.token;
      })
      : Promise.reject(new Error('The kiosk has no saved sign-in to renew.'))
    ).finally(() => { kioskRefreshInFlight = null; });
  }
  return kioskRefreshInFlight;
}

export function createKioskApi(apiBase, http = axios) {
  const instance = http.create({ baseURL: apiBase });
  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem(KIOSK_TOKEN_KEY);
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  });
  instance.interceptors.response.use((response) => response, async (error) => {
    const original = error.config;
    if (error.response?.status !== 401 || !original || original._kioskRetry) throw error;
    original._kioskRetry = true;
    try { await refreshKioskToken(apiBase, http); } catch { throw error; }
    return instance(original);
  });
  return instance;
}
